import { set } from 'cerebral/operators'

export default [
  set('state:app.listUserHeaderAccessMenuOpen', false),
  function selectListModule({ input, state }) {
    state.set('app.listModule', input.module)
  }
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/selectListModule.js